import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-navy/15 bg-navy py-4">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-display text-lg font-bold uppercase tracking-wide text-white/90">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-electric" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
